import React, { useEffect, useState } from 'react';

import { useRouter } from 'next/router';
import { useToasts } from 'react-toast-notifications';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import DetailsContent from '@components/lpc/Help-center/ThematicsDetailsPage/DetailsContent/DetailsContent';
import Loading from '@components/lpc/Help-center/ThematicsDetailsPage/Loading/Loading';
import Navigation from '@components/lpc/Help-center/ThematicsDetailsPage/Navigation/Navigation';
import HelpCenterService from '@services/domain/Lpc/HelpCenterService';
import ObjectService from '@services/utils/ObjectService';

import css from './ThematicsDetails.module.scss';

type ThematicsDetailsPage = {
    questionID: number;
    thematicID: number;
    subThematicID: number;
};

const ThematicsDetails = ({ questionID, thematicID, subThematicID }: ThematicsDetailsPage) => {
    const router = useRouter();
    const { addToast } = useToasts();
    const { t } = useTranslateLpc('common');
    const [selectedThematic, setSelectedThematic] = useState<any>(null);
    const [selectedQuestionID, setSelectedQuestionID] = useState<number>(null);
    const [selectedSubThematicID, setSelectedSubThematicID] = useState<number>(null);
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [thematics, setThematics] = useState<any>([]);

    useEffect(() => {
        HelpCenterService.thematicsDetails()
            .then((thematics: any) => {
                if (ObjectService.hasContent(thematics.data)) {
                    setThematics(thematics.data);
                    setIsLoaded(true);
                    router.query.question !== null && setSelectedQuestionID(Number(router.query.question));
                    router.query.subThematic !== null && setSelectedSubThematicID(Number(router.query.subThematic));
                    router.query.thematic != null &&
                        setSelectedThematic(
                            thematics.data.find((thematic) => thematic.thematicID == router.query.thematic),
                        );
                    router.query.thematic == null && setSelectedThematic(thematics.data[0]);
                }
            })
            .catch(() => {
                addToast(t(`errors.DEFAULT_ERROR_MESSAGE`), {
                    appearance: 'error',
                    autoDismiss: true,
                });
            });
    }, []);

    useEffect(() => {
        thematicID && setSelectedThematic(thematics.find((thematic) => thematic.thematicID == thematicID));
        questionID && setSelectedQuestionID(questionID);
        subThematicID && subThematicID !== 0 && setSelectedSubThematicID(subThematicID);
    }, [questionID]);

    return (
        <>
            {!isLoaded && <Loading />}
            {isLoaded && (
                <div className={css.details_container}>
                    <div className={css.details_container__navigation}>
                        <Navigation
                            thematics={thematics}
                            selectedThematic={selectedThematic}
                            onSelectThematic={(thematic) => {
                                setSelectedThematic(thematic);
                            }}
                        />
                    </div>
                    <div className={css.details_container__details}>
                        <DetailsContent
                            searchedQuestion={selectedQuestionID}
                            searchedSubThematic={selectedSubThematicID}
                            thematicContent={selectedThematic}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default ThematicsDetails;
